import React from 'react'

class WPEngineLoader extends React.Component {
	render() {
		return <div className="wpe">
			<div className="loading-page">
				<div className="splash">
					<h1 className="splash-text-lines">
						<span>We’re validating your details.</span> <br />
						<span>Give us a moment.</span>
					</h1>
					<h2 className="splash-dont-refresh">Also, please do not refresh.</h2>
					<img className="splash-hedron spinning-loader" alt="" src="/assets/wpengine/hedron.svg"/>
				</div>
			</div>
		</div>
	}
}

export default WPEngineLoader
